import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

import { devSearchSchemaFor } from "@/modules/dev/registry/previews";

export const Route = createFileRoute("/dev/booking-timezone")({
  validateSearch: devSearchSchemaFor("booking-timezone"),
  component: lazyRouteComponent(
    () => import("@/modules/coaching/booking/dev/BookingTimezonePreview"),
    "BookingTimezonePreview",
  ),
});
